import axios from 'axios'
import qs from 'qs'

const isDev = process.env.VUE_APP_MODE === 'test' 

axios.interceptors.request.use(function (config) {
  let token = localStorage.getItem("usertoken")
  var host = window.location.host

  // host = "wx.rrxue.cn"
  host = "ks.rrxue.cn"
  // host = "gj.rrxue.cn"
  // host = "wx.029985.com"
  if (token == undefined) {
    token = ""
    if(process.env.NODE_ENV === 'development') {
      // token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1bmlvbmlkIjoiMTE5NDMiLCJ1bmlvbm5hbWUiOiJycnh1ZSIsInN0YWZmaWQiOjAsInN0YWZmbmFtZSI6IiIsInVzZXJyb2xlIjowLCJ1bmlvbnR5cGUiOjAsImlzc3VlciI6InVuaW9uIiwiYXVkaWVuY2UiOiIifQ.JnNcsFz7C1uwEroKw5RrFJUlRSYuqLVL7PO-2s_pqkQ"
      token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyaWQiOjE3MTY2NDQ4LCJ1c2VybmFtZSI6InJyeHVlIiwidW5pb25pZCI6IjExOTQzIiwiaXNzdWVyIjoidXNlciIsImF1ZGllbmNlIjoiIn0.OSE0iv4AstnlHXu2Mk6O_NHzE135dHufxp_4AzRK_C0"
      // token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyaWQiOjE0NjQ5NzEyLCJ1c2VybmFtZSI6Ijk2NjQ2MDZhIiwidW5pb25pZCI6IjUzNjAzIiwiaXNzdWVyIjoidXNlciIsImF1ZGllbmNlIjoiIn0.kZYaOGayYhOWg-wGv16BavziWVvaKTKje129s-89Kmg"
      // token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyaWQiOjE0NjQ5NzEyLCJ1c2VybmFtZSI6Ijk2NjQ2MDZhIiwidW5pb25pZCI6IjExOTQzIiwiaXNzdWVyIjoidXNlciIsImF1ZGllbmNlIjoiIn0.iS_KMPWMS5y-ojH3zooMBrOrfnmhqwkknGodWWtB8Lk"
    }
  }
  config.params = {
    stamp: new Date().getTime(),
    // host: host,
    token: token,
    ...config.params
  }
  if(process.env.NODE_ENV === 'development') {
    config.params.host = host
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

export const uri = isDev ? 'http://192.168.0.164' :  'https://uapi.233.com';
// export const uri = isDev ? 'https://uapi.233.com' :  'https://uapi.233.com';


export const GetLoginStatus = (params, callback) => get('/UnionInfo/Info/GetLoginStatus', params, callback)// 登陆状态
export const GetFooterByHost = (params, callback) => get('/unioninfo/info/GetFooterByHost', params, callback)// 获取页尾
export const Statistics = (params, callback) => get('/UnionInfo/Info/Statistics', params, callback)// cnzz
export const GetKeFuByHost = (params, callback) => get('/unioninfo/info/GetKeFuByHost', params, callback)// 客服
export const GetUnionLogoByHost = (params, callback) => get('/unioninfo/info/GetUnionLogoByHost', params, callback)// 获取logo

export const GetActivityTemplate = (params, callback) => get('/order/ActivityCoupon/GetActivityTemplate', params, callback)// 获取模板时间与当前阶段状态
export const GetHongBaoInfo = (params, callback) => get('/order/ActivityCoupon/GetHongBaoInfo', params, callback)// 专题模板获取红包板块
export const LingQuHongBao = (params, callback) => post('/order/ActivityCoupon/LingQuHongBao', params, callback)// 领红包
export const GetGoodCourse = (params, callback) => get('/order/ActivityCoupon/GetGoodCourse', params, callback)// 好课快抢模块
export const GetPinTuanBaoKuanCourse = (params, callback) => get('/order/ActivityCoupon/GetPinTuanBaoKuanCourse', params, callback)// PC 拼团特惠专区，爆款专区
export const GetBzNumCourseList = (params, callback) => get('/order/ActivityCoupon/GetBzNumCourseList', params, callback)// 活动模板购课弹框选课程时调用
export const GetEcartCount = (params, callback) => get('/order/ActivityCoupon/GetEcartCount', params, callback)// 获取购课程数量

export const get = (api, params, callback) => axios.get(uri + api, {
  params: params
}).then(res => {
  callback(res.data)
})

export const post = (api, params, callback) => axios.post(uri + api, qs.stringify(params))
.then(res => {
  callback(res.data)
})